// --- El host del servicio de la radio ---
//
// 🔴 **Un solo sitio donde está escrito.** Hasta el 11.09.26 el host aparecía
// 41 veces repartidas por veinte archivos, así que cambiarlo era una revisión
// completa en vez de tocar un valor.
//
// Y ese trabajo se pagó solo al día siguiente: **el 12.09.26 la marca volvió
// atrás** —se vuelve a Astra FM, nombre y dominio— y devolver el servicio a su
// sitio fue **esta línea**, no una cacería por veinte archivos. Lo dijo el
// servidor con todas las letras al dar la orden de vuelta.
//
// El servicio responde por los dos dominios y va a seguir haciéndolo: no hay
// corte ni fecha límite, y el de Dynamo no se apaga de golpe.
//
// ⚠️ **Hay dos sitios que esto NO alcanza**, y hay que tocarlos a mano cada vez:
// `public/service-worker.js` y `public/tv-og.php`. No pasan por el empaquetador,
// así que no pueden importar nada de aquí.
export const LISTEN = "https://listen.astra.fm";
